// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoteForm_subForm__Ic-dd {
    border-left: .5rem solid lightgray;
    border-radius: .2rem;
    padding-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/NoteForm/NoteForm.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,kBAAkB;AACtB","sourcesContent":[".subForm {\n    border-left: .5rem solid lightgray;\n    border-radius: .2rem;\n    padding-left: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subForm": `NoteForm_subForm__Ic-dd`
};
export default ___CSS_LOADER_EXPORT___;
